.hour-options {
  min-width: 180px;
  text-transform: uppercase;
}

.minute-options {
  min-width: 180px;
  text-transform: capitalize;
}
